import React from 'react';
import './SearchSummary.css';

function SearchSummary({ fileResultsCount, searchQuery, searchAttempted, searchCount }) {
  if (!searchAttempted || !searchQuery) {
    return null; // Don't render anything if no search has been made
  }

  if (searchQuery.length < 3) {
    return (
      <div className="search-summary-container">
        <b>The keyword is not correct. Please enter at least 3 characters.</b>
        <div className="search-count">ចំនួនការស្វែងរកទាំងអស់: {searchCount}</div>
      </div>
    );
  }

  return (
    <div className="search-summary-container">
      <b>រកឃើញ {fileResultsCount} លទ្ធផល ដែលត្រូវនឹងការស្វែងរករបស់អ្នក "<strong>{searchQuery}</strong>"</b>
      <div className="search-count">ចំនួនការស្វែងរកទាំងអស់: {searchCount}</div>
    </div>
  );
}

export default SearchSummary;
